import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import {
  PROJECT_NAV_DOT_DISMISS_EVENT,
  dismissProjectNavDot,
  shouldShowProjectNavDot,
} from "~/utils/ui";

/**
 * 导航「项目」上的新功能红点：进入过项目广场后不再显示
 */
const useProjectNavDot = () => {
  const router = useRouter();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (router.pathname.startsWith("/projects")) {
      dismissProjectNavDot();
    }
  }, [router.pathname]);

  useEffect(() => {
    const update = () => setShow(shouldShowProjectNavDot());
    update();
    window.addEventListener(PROJECT_NAV_DOT_DISMISS_EVENT, update);
    return () =>
      window.removeEventListener(PROJECT_NAV_DOT_DISMISS_EVENT, update);
  }, []);

  return show;
};

export default useProjectNavDot;
